<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import {mapActions, mapState} from "vuex";
export default {
    name: "FormMixin",
    computed: {
        ...mapState('form', {
            form: state => state.form,
        }),
    },
    created() {
        this.$store.commit('application/setFormId', this.form.id)
    },
    methods: {
        ...mapActions("form", []),
    },
}
</script>
